import { render, staticRenderFns } from "./MovieRight.vue?vue&type=template&id=79e541c0&scoped=true&"
import script from "./MovieRight.vue?vue&type=script&lang=js&"
export * from "./MovieRight.vue?vue&type=script&lang=js&"
import style0 from "./MovieRight.vue?vue&type=style&index=0&id=79e541c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e541c0",
  null
  
)

export default component.exports